module.exports = __webpack_public_path__ + "dashboard/img/settings.abf96374703617103b4b95da1b8db49e.svg";